import PageRequest from "@/store/entities/page-request";

export default class PageWorkOrderRequest extends PageRequest {
  /**标题/设备编号/工单编号 */
  keyword: string;
  /**区域Id */
  areaId: number;
  /**工单类型 */
  orderTypeId: number;
  /**问题类型 */
  problemTypeId: number;
  /**工单等级 */
  orderLevelId: number;
  /**工单状态 */
  orderState: number;
  /**是否个人工单 */
  isPersion: number;
}
